import React, { useContext } from "react";

import { useResponse, useOtherTextResponse } from "screens/question/hooks";
import {
  Wrapper,
  OptionWrapper,
  Checkbox,
  CheckMarkImage,
  Label,
  CheckboxWrapper,
  OtherTextWrapper,
} from "./styled";
import { TextInputWithMedia } from "screens/question/themeB/types/text-input";
import { BoldText, ScrollContext } from "components";

export const CheckBoxQuestion = ({ question }) => {
  const {
    options,
    selectedOptions,
    selectOption,
    singleSelect,
    RTL,
  } = useResponse(question);
  const scrollDownBy = useContext(ScrollContext);

  const singleLine =
    question.options.length < 4 ||
    question.options.some(o => o.text.length > 30);

  return (
    <Wrapper $RTL={RTL}>
      {options.map(option => {
        const isSelected = selectedOptions[option.virtual_id];
        return (
          <OptionWrapper key={option.id} $singleLine={singleLine}>
            <CheckboxWrapper
              $RTL={RTL}
              $isSelected={isSelected}
              onPress={() => {
                selectOption(option);
                if (option.is_other && !isSelected) {
                  setTimeout(() => scrollDownBy(120), 50);
                }
              }}
            >
              <Checkbox $isSelected={isSelected} $singleSelect={singleSelect}>
                <CheckMarkImage
                  $isSelected={isSelected}
                  source={require("../../../../../assets/images/check-mark.png")}
                />
              </Checkbox>
              <Label $RTL={RTL} $isSelected={isSelected}>
                <BoldText>{option.text}</BoldText>
              </Label>
            </CheckboxWrapper>
            {isSelected && option.is_other && (
              <OtherText question={question} option={option} />
            )}
          </OptionWrapper>
        );
      })}
    </Wrapper>
  );
};

const OtherText = ({ question, option }) => {
  const { value, placeholder, onChange } = useOtherTextResponse(
    question,
    option,
  );
  return (
    <OtherTextWrapper>
      <TextInputWithMedia
        value={value}
        $fontSize={14}
        multiline={true}
        numberOfLines={3}
        onChangeText={onChange}
        placeholder={placeholder}
        question={question}
        option={option}
      />
    </OtherTextWrapper>
  );
};
